import "./HtmlDocument.scss";
import React, { useState, useEffect } from "react";

function HtmlDocument(props) {
  const [error, setError] = useState(null);
  const [html, setHtml] = useState(null);

  useEffect(() => {
    fetch(props.location)
      .then((res) => res.text())
      .then(
        (result) => {
          setHtml(result);
        },
        (error) => {
          setError(error);
        }
      );
  }, [props.location]);

  useEffect(() => {
    var contentElement = document.getElementById("content");
    contentElement
      .querySelectorAll("table")
      .forEach((el) => el.classList.add("table", "table-dark"));
  }, [html]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else {
    return (
      <div className="quip-html" dangerouslySetInnerHTML={{ __html: html }} />
    );
  }
}

export default HtmlDocument;
